// Field formats rc-picker 4 shipped per locale and antd 6's @rc-component/picker dropped, keyed by
// `DatePicker.lang.locale`. Without them every picker falls back to ISO `YYYY-MM-DD`.
export const pickerDateFormats: Partial<Record<string, string>> = {
  am_ET: 'D/M/YYYY',
  ar_EG: 'M/D/YYYY',
  az_AZ: 'D.M.YYYY',
  bg_BG: 'D M YYYY',
  bn_BD: 'M/D/YYYY',
  by_BY: 'D-M-YYYY',
  ca_ES: 'D/M/YYYY',
  cs_CZ: 'D.M.YYYY',
  da_DK: 'D/M/YYYY',
  de_DE: 'D.M.YYYY',
  el_GR: 'D/M/YYYY',
  en_GB: 'D/M/YYYY',
  en_US: 'M/D/YYYY',
  es_ES: 'D/M/YYYY',
  es_MX: 'D/M/YYYY',
  et_EE: 'D.M.YYYY',
  eu_ES: 'YYYY/M/D',
  fa_IR: 'M/D/YYYY',
  fi_FI: 'D.M.YYYY',
  fr_BE: 'D/M/YYYY',
  fr_CA: 'DD/MM/YYYY',
  fr_FR: 'DD/MM/YYYY',
  ga_IE: 'D/M/YYYY',
  gl_ES: 'D/M/YYYY',
  he_IL: 'M/D/YYYY',
  hi_IN: 'M/D/YYYY',
  hr_HR: 'D.M.YYYY',
  hu_HU: 'YYYY/MM/DD',
  id_ID: 'D/M/YYYY',
  is_IS: 'D/M/YYYY',
  it_IT: 'D/M/YYYY',
  ja_JP: 'YYYY年M月D日',
  ka_GE: 'M/D/YYYY',
  kk_KZ: 'D-M-YYYY',
  km: 'YYYY-M-D',
  ku: 'D/M/YYYY',
  kn_IN: 'M/D/YYYY',
  ko_KR: 'YYYY-MM-DD',
  lt_LT: 'YYYY-MM-DD',
  lv_LV: 'D.M.YYYY',
  mk_MK: 'D.M.YYYY',
  ml_IN: 'M/D/YYYY',
  mn_MN: 'YYYY/MM/DD',
  ms_MY: 'M/D/YYYY',
  my_MM: 'M/D/YYYY',
  nb_NO: 'DD.MM.YYYY',
  ne_NP: 'M/D/YYYY',
  nl_BE: 'D-M-YYYY',
  nl_NL: 'D-M-YYYY',
  pl_PL: 'D/M/YYYY',
  pt_BR: 'D/M/YYYY',
  pt_PT: 'D/M/YYYY',
  ro_RO: 'D/M/YYYY',
  ru_RU: 'D-M-YYYY',
  si_LK: 'YYYY/M/D',
  sk_SK: 'D.M.YYYY',
  sl_SI: 'DD.MM.YYYY',
  sr_Cyrl_RS: 'DD.MM.YYYY',
  sr_RS: 'DD.MM.YYYY',
  sv_SE: 'YYYY-MM-DD',
  ta_IN: 'M/D/YYYY',
  th_TH: 'D/M/YYYY',
  tk_TK: 'D/M/YYYY',
  tr_TR: 'DD/MM/YYYY',
  ug_CN: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
  uk_UA: 'D-M-YYYY',
  ur_PK: 'M/D/YYYY',
  uz_UZ: 'M/D/YYYY',
  vi_VN: 'D/M/YYYY',
  zh_TW: 'YYYY年M月D日',
}
